const defaultBackendBase = "https://membershipbackend.buzzvibe.com";

const isMembershipDomain =
	typeof window !== "undefined" && /^membership\.buzzvibe\.com$/i.test(window.location.hostname);

const configuredServer = process.env.REACT_APP_SERVER_URL;

export const server =
	isMembershipDomain
		? "/api/v2"
		: configuredServer || (isMembershipDomain ? "/api/v2" : `${defaultBackendBase}/api/v2`);

export const backend_url = process.env.REACT_APP_BACKEND_URL || defaultBackendBase;




